import 'css-chunksrc/client/pages/documentsPage/documentsPage/creationMenu/styles.scss';export default {
  "creationMenu": "_creationMenu_1jkk7_1",
  "button": "_button_1jkk7_5",
  "icon": "_icon_1jkk7_25",
  "iconBox": "_iconBox_1jkk7_33",
  "menu": "_menu_1jkk7_42",
  "menuItem": "_menuItem_1jkk7_54",
  "menuText": "_menuText_1jkk7_67",
  "fileIcon": "_fileIcon_1jkk7_85",
  "lockIcon": "_lockIcon_1jkk7_90",
  "block": "_block_1jkk7_94"
};